<template>
  <div :class="!ishtmlContent || tooltip ? 'description-inline' : 'description-inline-block'" v-if="getDescription || hasSlot" :id="id">
    <template v-if="tooltip">
      <w-tooltip v-if="ishtmlContent">
        <template v-if="hasSlot">
          <slot />
        </template>

        <span v-else v-html="getDescription" />
      </w-tooltip>

      <w-tooltip v-else :tooltip="getDescription" />
    </template>

    <template v-else>
      <span class="description-content" v-if="ishtmlContent">
        <slot v-if="hasSlot" />

        <span v-else v-html="getDescription" />
      </span>

      <span class="description-content" v-else>
        <br v-if="newLine === null ? !tooltip : newLine" />
        {{ getDescription }}
      </span>
    </template>
  </div>
</template>

<script>
import titleMixin from '../mixins/titleMixin';

export default {
  name: 'w-description',
  mixins: [titleMixin],
  props: {
    value: {
      type: String,
      required: false
    },
    model: {
      type: Object,
      required: false
    },
    tooltip: {
      type: Boolean,
      default: false
    },
    htmlContent: {
      type: Boolean,
      default: false
    },
    newLine: {
      type: Boolean,
      default: null
    },
    id: {
      type: [String, Boolean],
      default: false
    }
  },
  computed: {
    hasSlot() {
      return !!this.$slots.default;
    },
    ishtmlContent() {
      return this.htmlContent || this.hasSlot;
    }
  }
};
</script>

<style>
.description-block {
  display: block;
}
.description-inline {
  display: inline;
}
.description-content {
  color: gray;
}
</style>
